export const AGOURA = 'Agoura';
export const BALDWIN = 'Baldwin';
export const CARSON = 'Carson';
export const CASTAIC = 'Castaic';
export const DOWNEY = 'Downey';
export const LANCASTER = 'Lancaster';
export const PALMDALE = 'Palmdale';
export const LOCATIONS = [AGOURA, BALDWIN, CARSON, CASTAIC, DOWNEY, LANCASTER, PALMDALE];
